import React, { useContext } from 'react';
import { Grid, Header } from 'semantic-ui-react';
import FilterCategory from './FilterCategory';
import ProjectExclusion from './ProjectExclusion';
import SearchContext from '../../../contexts/SearchContext';

const Filters = () => {
  const {
    searchResult, appliedFilters, appliedExclusions, clearFilters, toggleFilter,
  } = useContext(SearchContext);
  return (
    <div className="filter-section">
      <Grid.Row>
        <Grid
          columns="equal"
          className="heading"
        >
          <Grid.Column>
            <Header as="h4" className="text">
              Filters
            </Header>
          </Grid.Column>
          {(appliedFilters.length + appliedExclusions.length > 0) && (
          <Grid.Column textAlign="right">
            <Header as="h4" className="span-link">
              <span role="button" tabIndex={0} onClick={clearFilters} onKeyDown={clearFilters}>Clear All</span>
            </Header>
          </Grid.Column>
          )}
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid stackable className="categories">
          {searchResult.facets.map((facet) => {
            const currFilters = appliedFilters.find((x) => x.categoryId === facet.categoryId);
            const selected = currFilters ? currFilters.values : [];
            if (facet.items.length > 0) {
              return (
                <div className="filter-category" key={facet.id}>
                  <FilterCategory
                    facet={facet}
                    selected={selected}
                    toggleFilter={toggleFilter}
                  />
                </div>
              );
            }
            return '';
          })}
          {<ProjectExclusion />}
        </Grid>
      </Grid.Row>
    </div>
  );
};

export default Filters;
